<template>
    <div class="analysisList">
        <el-row>
            <el-col :span="12">
                <el-card shadow="always" class="item-car">
                    <div class="item-car-header">
                        <div class="header-placeholder" />
                        <div class="header-title">造血干细胞志愿者捐献招募情况</div>
                    </div>
                    <div class="item-car-content">
                        <div class="content-search">
                            年份：
                            <el-select
                                    placeholder="请选择"
                                    v-model="yearvalue"
                                    @change="volunChange"
                                >
                                    <el-option
                                        v-for="item in optionsyear"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.label">
                                    </el-option>
                            </el-select>
                            <el-button class="btnExport" type="danger" size="small" icon="el-icon-download" @click="exportVolun()" v-access:modify>
                                导出
                            </el-button>
                        </div>
                        <div id="man" class="item-car-echart" />
                        <el-table
                            :data="donationstemcellData"
                            style="width: 100%"
                            :header-cell-style="{background:'rgb(242, 242, 242)', fontFamily:'Helvetica',fontSize:'14px'}"
                            id="donationstemcellOut"
                        >
                            <el-table-column prop="Company" label="单位" :show-overflow-tooltip="true"/>
                            <el-table-column prop="Number" label="招募数量" align="center" width="120" />
                            <el-table-column prop="Data" label="入库数据" align="center" width="120" />
                        </el-table>
                    </div>
                </el-card>
                <el-card shadow="always" class="item-car">
                    <div class="item-car-header">
                        <div class="header-placeholder" />
                        <div class="header-title">器官捐献志愿登记情况统计表</div>
                    </div>
                    <div class="item-car-content">
                        <div class="content-search">
                            年份：
                            <el-select
                                placeholder="请选择"
                                v-model="donationorganvalue"
                                @change="donationorganStatisticsChange"
                            >
                                <el-option
                                    v-for="item in donationorganyear"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                            <el-button class="btnExport" type="danger" size="small" icon="el-icon-download" @click="exportdonationorgan()" v-access:modify>
                                导出
                            </el-button>
                        </div>
                        <div id="man2" class="item-car-echart" />
                        <el-table
                            :data="donationOrganData"
                            style="width: 100%"
                            :header-cell-style="{background:'rgb(242, 242, 242)', fontFamily:'Helvetica',fontSize:'14px'}"
                            id="donationorganout"
                        >
                            <el-table-column prop="Company" label="单位" :show-overflow-tooltip="true" />
                            <el-table-column prop="LastNumber" label="上一年" align="center" width="100" />
                            <el-table-column prop="Number" label="今年" align="center" width="100" />
                            <el-table-column prop="Growth" label="较上一年增幅" align="center" width="110"  />
                        </el-table>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card shadow="always" class="item-car">
                    <div class="item-car-header">
                        <div class="header-placeholder" />
                        <div class="header-title">救护员培训情况表</div>
                    </div>
                    <div class="item-car-content">
                        <div class="content-search">
                            年份：
                            <el-date-picker
                                v-model="yearQuery"
                                type="monthrange"
                                align="center"
                                :clearable="false"
                                unlink-panels
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy"
                                value-format="yyyy"
                                @change="onChangeRescue" 
                            />
                            <el-button type="danger" class="btnExport" size="small" icon="el-icon-search" @click="yearRescueQuery">
                                查询
                            </el-button>
                            <el-button type="danger" class="btnExport" size="small" icon="el-icon-download" @click="exportTrain(trainData)" v-access:modify>
                                导出
                            </el-button>
                        </div>
                        <div id="man1" class="item-car-echart" />
                        <el-table
                            id="trainout"
                            :data="trainData"
                            style="width: 100%"
                            show-summary
                            :header-cell-style="{background:'rgb(242, 242, 242)', fontFamily:'Helvetica',fontSize:'14px'}"
                        >
                            <el-table-column prop="Date" label="年份"  align="center" />
                            <el-table-column prop="Number" label="人数" align="center" />
                        </el-table>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import api from "@/modules/zjrc/api";
    import echarts from 'echarts';
    import FileSaver from 'file-saver'
    import XLSX from 'xlsx'


    export default {
        name: "list",
        data() {
            return {
                optionsyear: [],
                yearvalue: '',

                //救护
                yearQuery: '',
                year: '',
                lastyear: '',
                rescueDate: [],
                rescueNumber: [],


                //造血干细胞
                donationStemcellInitial: [],
                donationstemcellData: [],
                trainData: [],
                trainDate: '',
                columnarDate: [],
                columnarNumber: [],
                donationseriesData: [],


                //器官
                donationOrganInitial: [],
                donationOrganData: [],
                donationorganyear: [],
                donationorganvalue: '',
                organDate: [],
                organNumber: []

            }
        },
        methods: {
            drawCircular() {
                let that = this
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('man'))
                // 绘制图表
                myChart.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)',
                        confine: true
                    },
                    color: ["#E64744", "#0070C0"],
                    series: [
                        {
                            name: '类型',
                            type: 'pie',
                            // radius: '55%',
                            center: ['50%', '50%'],
                            data: [
                                {name: '入库数据', value: that.donationStemcellInitial[0]['Data']},
                                {name: '招募数量', value: that.donationStemcellInitial[0]['Number']}
                            ],
                            label: {
                                normal: {
                                    position: "inside",
                                }
                            }
                        }
                    ]
                });
            },

            onChangeRescue(val) {
                let that = this;
                that.year = val[1];
                that.lastyear = val[0];

            },
            //救护员查询
            yearRescueQuery() {
                let that = this;
                let params = {
                    Year: that.year,
                    LastYear: that.lastyear
                }
                api.DataAnalysisRescueStatistics(params).then((res) => {
                    that.trainData = res.data.Data;
                    that.columnarDate = []
                    that.columnarNumber = []
                    if(that.trainData.length > 0){
                        that.trainData.forEach(item=>{
                            that.columnarDate.push(item.Date)
                            that.columnarNumber.push(item.Number)
                        })
                    }
                    that.drawColumnar();
                })
            },

            drawColumnar() {
                let that = this
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('man1'))
                myChart.setOption({
                    tooltip: {},
                    xAxis: {
                        data: that.columnarDate
                    },
                    yAxis: {
                        max: 10,
                        min: 0,
                        minInterval: 1,
                    },
                    grid: {
                        left: '3%',
                        right: '3%',
                        top: '10%',
                        bottom: '20%',
                        containLabel: true
                    },
                    series: [{
                        name: '人数',
                        type: 'bar',
                        barWidth: 20,
                        data: that.columnarNumber,
                        itemStyle: {
                            normal: {
                                color: 'rgb(230, 25, 25)', // 设置柱子颜色
                                label: {
                                    show: true, // 柱子上显示值
                                    position: 'inside', // 值在柱子上方显示
                                    textStyle: {
                                        color: '#fff' // 值得颜色
                                    }
                                }
                            }
                        }
                    }]
                });
            },
            drawOrgan() {
                let that = this
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('man2'))
                myChart.setOption({
                    tooltip: {},
                    xAxis: {
                        data: that.organDate
                    },
                    yAxis: {
                        max: 10,
                        min: 0,
                        minInterval: 1,
                    },
                    grid: {
                        left: '3%',
                        right: '3%',
                        top: '10%',
                        bottom: '20%',
                        containLabel: true
                    },
                    series: [{
                        name: '人数',
                        type: 'bar',
                        barWidth: 20,
                        data: that.organNumber,
                        itemStyle: {
                            normal: {
                                color: 'rgb(230, 25, 25)', // 设置柱子颜色
                                label: {
                                    show: true, // 柱子上显示值
                                    position: 'inside', // 值在柱子上方显示
                                    textStyle: {
                                        color: '#fff' // 值得颜色
                                    }
                                }
                            }
                        }
                    }]
                });
            },
            volunChange(val) {
                let that = this;
                let params = {
                    Year: val
                }
                api.DataAnalysisQueryYearStatistics(params).then((res) => {
                    that.donationstemcellData = res.data.Data
                })
            },
            loadData() {
                let that = this;
                api.DataAnalysisStatisticsYear().then((res) => {
                    let i = 0
                    res.data.Data.forEach((r) => {

                        that.optionsyear = [{
                            value: i++,
                            label: r['Year']
                        }]
                    })
                })

                api.DataAnalysisRescueStatistics().then((res) => {
                    that.trainData = res.data.Data
                    that.trainData.forEach(function (r) {
                        that.columnarDate.push(r['Date'])
                        that.columnarNumber.push(r['Number'])
                    })
                    that.drawColumnar();
                });
                api.DataAnalysisDonationStemCellStatistics().then((res) => {
                    that.donationStemcellInitial = res.data.Data;
                    that.drawCircular();
                    that.donationstemcellData = [
                        {
                            Company: res.data.Data[0]['Company'],
                            Data: res.data.Data[0]['Data'],
                            Number: res.data.Data[0]['Number']
                        }
                    ]
                });
                api.DataAnalysisDonationOrganStatistics().then((res) => {
                    that.donationOrganInitial = res.data.Data
                    that.donationorganvalue = res.data.Data[0]['Date']
                    let i = 0
                    that.donationOrganInitial.forEach((r) => {
                        that.organDate.push(r['Date']);
                        that.organNumber.push(r['Number']);
                        that.donationorganyear.push({value: i++, label: r['Date']})
                    })
                    that.drawOrgan();
                    that.setGrowth(0);
                })
            },
            setGrowth(val) {
                let that = this;
                let s = that.donationOrganInitial[val + 1] === undefined ? 0 : that.donationOrganInitial[val + 1]['Number'];
                let growth = s === 0 ? '0%' : ((((that.donationOrganInitial[val]['Number'] - s) / s).toFixed(2)) * 100) + '%'
                that.donationOrganData = [
                    {
                        'Company': '湛江市红十字会',
                        'LastNumber': s,
                        'Number': that.donationOrganInitial[val]['Number'],
                        'Growth': growth
                    }
                ];
            },
            donationorganStatisticsChange(val) {
                let that = this;
                that.setGrowth(val)
            },
            //造血干细胞志愿者导出
            exportVolun() {
                let tables = document.getElementById("donationstemcellOut");
                let table_book = XLSX.utils.table_to_book(tables);
                let table_write = XLSX.write(table_book, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([table_write], {type: "application/octet-stream"}),
                        "造血干细胞志愿者捐献招募情况表.xlsx"
                    );
                } catch (e) {
                    if (typeof console !== "undefined")
                        window.console.log(e, table_write);
                }
                return table_write;
            },
            //器官捐献志愿登记情况导出
            exportdonationorgan() {
                let tables = document.getElementById("donationorganout");
                let table_book = XLSX.utils.table_to_book(tables);
                let table_write = XLSX.write(table_book, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([table_write], {type: "application/octet-stream"}),
                        "器官捐献志愿登记情况统计表.xlsx"
                    );
                } catch (e) {
                    if (typeof console !== "undefined")
                        window.console.log(e, table_write);
                }
                return table_write;
            },
            exportTrain(list) {
                let tables = document.getElementById("trainout");
                let table_book = XLSX.utils.table_to_book(tables);
                let table_write = XLSX.write(table_book, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([table_write], {type: "application/octet-stream"}),
                        "救护员培训情况表.xlsx"
                    );
                } catch (e) {
                    if (typeof console !== "undefined")
                        window.console.log(e, table_write);
                }
                return table_write;
            }

        },
        mounted() {
            this.loadData();
        }
    }
</script>

<style lang="scss" scoped>
    .grid-content {
        background-color: rgb(44, 143, 121);
        border-radius: 4px;
        content: inherit;
        min-height: 150px;
        min-width: 100px;
    }

    .hheiht {
        height: 20px;
    }

    .spanSize {
        font-size: 15px;
        margin: 0 auto;
    }

    .spanTop {
        /*style="border-left: 5px solid red;font-size: 28px"*/
        border-left: 5px solid red;
        font-size: 28px;
    }
    .analysisList{
        max-height: 90vh;
        overflow-y: auto;
        background-color: #fff;
        padding: 10px;
        margin: 5px;
        .item-car{
            margin: 0 10px 15px 0;
            .item-car-header{
                width: 100%;
                display: flex;
                .header-placeholder{
                    width: 3px;
                    background-color: red;
                    margin-right: 5px;
                }
                .header-title{
                    font-size: 16px;
                    font-weight: bold;
                }
            }
            .item-car-content{
                .content-search{
                    margin: 5px;
                    padding: 5px;
                    .btnExport{
                        margin-left: 10px;
                    }
                    /deep/ .el-input__inner{
                        padding: 3px 10px !important;
                        height: 40px !important;
                    }
                }
                .item-car-echart{
                    width: 100%;
                    height: 200px;
                }
            }
        }
    }
</style>
